import Photoshop from "./photoshop.vue";

export default Photoshop;
